import { customerMarketShopfrontApi } from '@envato/foundation-types'
import { ActionCreator } from 'react-redux'
import { ThunkAction } from 'redux-thunk'

import { setCanonicalPath, setSeoMeta } from '../actions/common'
import { getBookmarksForItems } from '../actions/user/bookmark'
import { reportPageType } from '../analytics'
import { reportProductsImpressions } from '../analytics/resultAnalytics'
import { IRootState } from '../reducers'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'
import { ICommonLocation } from '../utils/location/types'

export enum TypeKeys {
  GET_TOP_SELLERS_PAGE_API_REQUEST = 'GET_TOP_SELLERS_PAGE_API_REQUEST',
  GET_TOP_SELLERS_PAGE_API_SUCCESS = 'GET_TOP_SELLERS_PAGE_API_SUCCESS',
  GET_TOP_SELLERS_PAGE_API_FAIL = 'GET_TOP_SELLERS_PAGE_API_FAIL'
}

export interface IGetTopSellersPageApiRequestAction {
  type: TypeKeys.GET_TOP_SELLERS_PAGE_API_REQUEST
}

export interface IGetTopSellersPageApiSuccessAction {
  type: TypeKeys.GET_TOP_SELLERS_PAGE_API_SUCCESS
  payload: Readonly<customerMarketShopfrontApi.topSellers.IResult>
}

export interface IGetTopSellersPageApiFailAction {
  type: TypeKeys.GET_TOP_SELLERS_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetTopSellersPageApiRequestAction
  | IGetTopSellersPageApiSuccessAction
  | IGetTopSellersPageApiFailAction

export const onBeforeTopSellersPageView = (): ThunkAction<
  void,
  IRootState,
  void
> => (dispatch, getState) => {
  const { topSellers } = getState().topSellersPage
  const currentSite = getState().common.currentSite

  reportPageType('other')

  if (topSellers) {
    reportProductsImpressions({
      items: topSellers.matches,
      currentSite,
      itemRankOffset: 1,
      page: 'Top Sellers',
      section: 'Top Selling Items'
    })
  }
}

export const fetchTopSellersPageDataBySite: ActionCreator<
  ThunkAction<Promise<ActionTypes>, IRootState, void>
> = (location: ICommonLocation, apiUrlPrefix: string) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    const requestAction: IGetTopSellersPageApiRequestAction = {
      type: TypeKeys.GET_TOP_SELLERS_PAGE_API_REQUEST
    }
    const { period = 'week', category } = location.query

    dispatch(requestAction)

    return axiosVerbose
      .get<customerMarketShopfrontApi.topSellers.IResult>(
        `${apiUrlPrefix}/shopfront_api/top_sellers/${currentSite}`,
        {
          params: {
            period,
            category
          }
        }
      )
      .then(response => {
        const action: IGetTopSellersPageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_TOP_SELLERS_PAGE_API_SUCCESS
        }
        if (response.data.top_sellers) {
          const itemIds = response.data.top_sellers.matches.map(item => item.id)
          dispatch(getBookmarksForItems(itemIds))
        }
        if (response.data.metadata) {
          dispatch(setSeoMeta(response.data.metadata))
        }
        if (category) {
          dispatch(
            setCanonicalPath(`${location.pathname}?category=${category}`)
          )
        }
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetTopSellersPageApiFailAction = {
          type: TypeKeys.GET_TOP_SELLERS_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}
